const variantName = 'copyright'

export default {
  [variantName]: {
    container: {
      color: 'inherit'
    }
  }
}
